<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <div class="d-flex justify-content-between">
        <h1 class="page-header">
          <a
            href="#"
            @click.prevent="$router.push({ name: 'student-profile' })"
            class="mr-2"
          >
            <i class="fas fa-arrow-left"></i>
          </a>
          {{
            $t('school.academic.operation.profile_mgt.studentProfile.pageTitle')
          }}
        </h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t(
                'school.academic.operation.profile_mgt.studentProfile.pageTitle'
              ),
              href: '/student-profiles'
            },
            {
              text: $t(
                'school.academic.operation.profile_mgt.studentProfile.showDetail'
              ),
              active: true
            }
          ]"
        />
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-5 col-sm-12">
          <ts-card>
            <profile-information v-model="edit_data" />
          </ts-card>
          <br />
        </div>
        <div class="col-lg-9 col-md-7 col-sm-12">
          <ts-card>
            <div class="overflow-auto">
              <ts-tabs target="gTab">
                <ts-tab>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.parent'
                    )
                  }}
                </ts-tab>
                <ts-tab>
                  <span>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.program'
                      )
                    }}
                  </span>
                </ts-tab>
                <ts-tab>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.schedule'
                    )
                  }}
                </ts-tab>
                <ts-tab>
                  <span>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.attendanceRecord'
                      )
                    }}
                  </span>
                </ts-tab>
                <ts-tab>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.paymentRecord'
                    )
                  }}
                </ts-tab>
                <ts-tab>
                  <span>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.disciplinaryRecord'
                      )
                    }}
                  </span>
                </ts-tab>
                <ts-tab>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.healthRecord'
                    )
                  }}
                </ts-tab>
                <ts-tab>
                  <span>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.accidenceRecord'
                      )
                    }}
                  </span>
                </ts-tab>
                <ts-tab>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.discountAndScholarship'
                    )
                  }}
                </ts-tab>
                <ts-tab>
                  <span>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.studentStatus'
                      )
                    }}
                  </span>
                </ts-tab>
              </ts-tabs>
            </div>
            <ts-card-wrapper>
              <ts-tab-panes name="gTab">
                <ts-tab-pane>
                  <parent v-model="edit_data" />
                </ts-tab-pane>
                <ts-tab-pane>
                  <program v-model="edit_data.enrollments" />
                </ts-tab-pane>
                <ts-tab-pane>3</ts-tab-pane>
                <ts-tab-pane>4</ts-tab-pane>
                <ts-tab-pane>5</ts-tab-pane>
                <ts-tab-pane>6</ts-tab-pane>
                <ts-tab-pane>7</ts-tab-pane>
                <ts-tab-pane>8</ts-tab-pane>
                <ts-tab-pane>9</ts-tab-pane>
                <ts-tab-pane>10</ts-tab-pane>
              </ts-tab-panes>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import ProfileInformation from './component/details/profile-information'
import Parent from './component/details/parent'
import { mapState } from 'vuex'
import Program from './component/details/program.vue';
export default {
  name: 'student-profile-show',
  components: {
    ProfileInformation,
    Parent,
    Program,
  },
  data() {
    return {
      loadingPreData: false
    }
  },
  created() {
    this.enrollments = this.value
  },
  computed: {
    ...mapState('studentProfile', ['edit_data'])
  },
  methods: {},
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('studentProfile/RESET_STATE')
      this.$store.commit('studentProfile/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
